import { Select } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import styled from 'styled-components';
import useDeepCompareEffect from 'use-deep-compare-effect';
import {
  getCampaignsForLandingZone,
} from '../../../home/containers/landing-zone/landing-zone-actions';

const { Option } = Select;

const StyledSelect = styled(Select)`
 ${p => p.extraStyles}
 font-size: 16px;
 font-weight: 400;
`;

const PlannerGroupToggle = ({
  popupContainer = triggerNode => triggerNode.parentNode,
  onChange,
  extraStyles,
  closeParent,
  disabled = false,
}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [preferredPlannerGroup, setPreferredPlannerGroup] = useState('');
  const [plannerGroup, setPlannerGroup] = useState();
  const { plannerGroups } = useSelector(state => state.user);

  useDeepCompareEffect(() => {
    if (plannerGroups?.length) {
      const localData = JSON.parse(
        localStorage.getItem('preferredPlannerGroupByServiceCenterId') ||
        '{}',
      );
      const serviceCenterId = JSON.parse(localStorage.getItem('serviceCenter'))?.value || '';
      setPreferredPlannerGroup(
        localData[serviceCenterId] || plannerGroups[0]?.id,
      );
    }
  }, [plannerGroups]);

  useEffect(() => {
    if (preferredPlannerGroup) {
      setPlannerGroup(preferredPlannerGroup);
      const localData = JSON.parse(
        localStorage.getItem('preferredPlannerGroupByServiceCenterId') ||
        '{}',
      );
      const serviceCenterId = JSON.parse(localStorage.getItem('serviceCenter'))?.value || '';
      if (serviceCenterId) {
        localStorage.setItem('preferredPlannerGroupByServiceCenterId', JSON.stringify({
          ...localData,
          [serviceCenterId]: preferredPlannerGroup,
        }));
      }
    }
  }, [preferredPlannerGroup]);

  const handleChange = (value) => {
    if (onChange) {
      onChange(value);
      setPlannerGroup(value);
    } else {
      setPreferredPlannerGroup(value);
      if (location.pathname.includes('/home')) {
        dispatch(getCampaignsForLandingZone({
          plannerGroup: value,
        }));
      }
    }
    if (closeParent) {
      closeParent();
    }
  };

  // getPopupContainer garantees that the select is rendered into the popover,
  // so scrolling/selecting/.. does not close the popover
  // https://codepen.io/anon/pen/xVBOVQ?editors=001
  return (
    <StyledSelect
      disabled={disabled}
      data-test-id='planner-group-toggle'
      getPopupContainer={popupContainer}
      value={plannerGroup}
      onChange={handleChange}
      allowClear={false}
      showSearch={true}
      extraStyles={extraStyles}
      dropdownMatchSelectWidth={false}
      filterOption={(input, option) => {
        if (option.children) {
          return option.children?.toLowerCase().indexOf(input?.toLowerCase()) >= 0;
        }
        return false;
      }}
    >
      {plannerGroups?.map(s =>
        <Option value={s.id} key={s.id}>
          {s.name}
        </Option>,
      )}
    </StyledSelect>
  );
};
PlannerGroupToggle.propTypes = {
  popupContainer: PropTypes.func,
  onChange: PropTypes.func,
  extraStyles: PropTypes.string,
  disabled: PropTypes.bool,
  closeParent: PropTypes.func,
};

export default PlannerGroupToggle;
